<template>
  <div class="pad-separator">
      <vb-icon
        class="mr-2"
        :name="'lamp_light'"
        :color="'#003B95'"
      />
      <span>
        <strong>E se ti spostassi un po'?</strong> Ecco delle ottime alternative nei dintorni di Roma.
      </span>
  </div>
</template>

<script>

export default {
  name: 'pad-separator',
}
</script>

<style lang="scss" scoped>

  .pad-separator {
    display: flex;
    background-color: #F3F7FE;
    color: #003B95;
    border: 1px solid #CEE1FF;
    align-items: center;
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    text-decoration: underline;
    margin-right: 10px;
  }

</style>